var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0885d5;}.b{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-311 -258)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(311 258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.064,1.3h-1.3V4.556A3.766,3.766,0,0,1,7.685,7.81a3.766,3.766,0,0,1,2.077,3.254v3.254h1.3a.651.651,0,0,1,0,1.3H.651a.651.651,0,1,1,0-1.3h1.3V11.064A3.766,3.766,0,0,1,4.03,7.81,3.766,3.766,0,0,1,1.952,4.556V1.3H.651a.651.651,0,1,1,0-1.3H11.064a.651.651,0,0,1,0,1.3Zm-7.81,9.762v3.254H8.46V11.064c0-1.857-2.3-2.568-2.632-2.6C5.857,8.463,3.254,9.066,3.254,11.064ZM8.46,1.3H3.254V4.556c0,2,2.606,2.6,2.632,2.6.271-.036,2.575-.748,2.575-2.6Z",
    transform: "translate(321.143 266.19)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingQuote);
export default __webpack_public_path__ + "static/media/pending-quote.c8b01dbcd2ee2f94e9588caa6aa7b915.svg";
export { ForwardRef as ReactComponent };